import { Box, Stack, Typography } from "@mui/material";
import { C } from "../../theme/dashboardCardTokens";

// Same title/subtitle/trailing-slot header used inside admin dashboard cards
// (CardHeader in pages/admin/Dashboard.js).
function PortalCardHeader({ title, subtitle, right }) {
  return (
    <Stack direction="row" alignItems="flex-start" justifyContent="space-between" sx={{ mb: 2, gap: 1.5 }}>
      <Box>
        <Typography sx={{ fontSize: 17, fontWeight: 700, color: C.ink }}>{title}</Typography>
        {subtitle && <Typography sx={{ fontSize: 13, color: C.textSecondary, mt: "2px" }}>{subtitle}</Typography>}
      </Box>
      {right}
    </Stack>
  );
}

export default PortalCardHeader;
